module.exports = __webpack_public_path__ + "img/complete.52a4d4dc.png";